(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentamesDetailController', VentamesDetailController);

    VentamesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ventames'];

    function VentamesDetailController($scope, $rootScope, $stateParams, previousState, entity, Ventames) {
        var vm = this;

        vm.ventames = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ventamesUpdate', function(event, result) {
            vm.ventames = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
